<template>
  <div id="empty-layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  methods: {}
};
</script>

<style lang="scss">
#empty-layout {
}
</style>